export default __webpack_public_path__ + "static/media/react.bd990a58.gif";